<template>
  <div >
       <main class="main-contents statement-cashflows">
            <div class="container">
                <!-- <h3 class="table-heading">YEAR ENDED 31 DECEMBER 2019</h3> -->
                <div class="table-wrapper">
                    <div class="custom-table">
                        <div class="trow table-tp-head">
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div class="sky_blue">2019</div>
                            <div>2018</div>
                        </div>
                        <div class="trow head purple border-0">
                            <div class="th" data-width="25%">&nbsp;</div>
                            <div class="th">Note(s) </div>
                            <div class="th">KD ’000</div>
                            <div class="th" data-width="6%">&nbsp;</div>
                        </div>
                        <div class="trow">
                            <div><b>Cash flows from operating activities</b></div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                        </div>
                        <div class="trow">
                            <div class="text-nowrap">Profit for the year before income tax, KFAS, NLST, and Zakat </div>
                            <div>&nbsp;</div>
                            <div>283,084</div>
                            <div>251,351</div>
                        </div>
                        <div class="trow">
                            <div>Adjustments for:</div>
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                        <div class="trow">
                            <div>Depreciation and amortization</div>
                            <div>10,11,12</div>
                            <div>375,954</div>
                            <div>229,532</div>
                        </div>
                        <div class="trow">
                            <div>ECL on financial assets</div>
                            <div></div>
                            <div>38,886</div>
                            <div>13,188)</div>
                        </div>
                        <div class="trow">
                            <div>Interest income</div>
                            <div>&nbsp;</div>
                            <div>(7,098)</div>
                            <div>(18,320)</div>
                        </div>
                        <div class="trow">
                            <div>Investment income</div>
                            <div>21</div>
                            <div>(1,007)</div>
                            <div>(3,930)</div>
                        </div>
                        <div class="trow">
                            <div>Share of results of associates and joint venture</div>
                            <div>9</div>
                            <div>(2,762)</div>
                            <div>2,444</div>
                        </div>
                        <div class="trow">
                            <div>Other income/ (expenses) </div>
                            <div>20.b</div>
                            <div>(38,955) </div>
                            <div>41,696</div>
                        </div>
                        <div class="trow">
                            <div>Gain on business combination</div>
                            <div>35</div>
                            <div>-</div>
                            <div>(30,931)</div>
                        </div>
                        <div class="trow">
                            <div>Finance costs</div>
                            <div>&nbsp;</div>
                            <div>110,723</div>
                            <div>69,173</div>
                        </div>
                        <div class="trow">
                            <div>Provision for impairment loss on property and equipment</div>
                            <div>1,133</div>
                            <div>-</div>
                            <div>9,648</div>
                        </div>
                        <div class="trow">
                            <div>Loss from currency revaluation</div>
                            <div>&nbsp;</div>
                            <div>13,058</div>
                            <div>14,764</div>
                        </div>
                        <div class="trow">
                            <div>Net monetary gain</div>
                            <div>33</div>
                            <div>(5,074)</div>
                            <div>(46,935)</div>
                        </div>
                        <div class="trow">
                            <div>Loss on sale of property and equipment</div>
                            <div>&nbsp;</div>
                            <div>1,400</div>
                            <div>202</div>
                        </div>
                        <div class="trow border-btm">
                            <div>Operating profit before working capital changes</div>
                            <div>&nbsp;</div>
                            <div class="sky-blue">768,209</div>
                            <div class="sky-blue">531,882</div>
                        </div>
                        <div class="trow">
                            <div>Increase in trade and other receivables</div>
                            <div>&nbsp;</div>
                            <div>(99,916)</div>
                            <div>(84,716)</div>
                        </div>
                        <div class="trow">
                            <div>Increase in inventories</div>
                            <div>&nbsp;</div>
                            <div>(243) </div>
                            <div>(3,730)</div>
                        </div>
                        <div class="trow">
                            <div>Increase in trade and other payables and deferred revenue</div>
                            <div>&nbsp;</div>
                            <div>4,495</div>
                            <div>70,706</div>
                        </div>
                        <div class="trow border-btm">
                            <div>Cash generated from operations</div>
                            <div>&nbsp;</div>
                            <div class="sky-blue">672,545</div>
                            <div class="sky-blue">514,142</div>
                        </div>
                        <div class="trow">
                            <div>Payments:</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                        </div>
                        <div class="trow">
                            <div>Income tax </div>
                            <div>&nbsp;</div>
                            <div>(16,614)</div>
                            <div>(10,629)</div>
                        </div>
                        <div class="trow">
                            <div>Kuwait Foundation for Advancement of Sciences (KFAS)</div>
                            <div>&nbsp;</div>
                            <div>(771)</div>
                            <div>(319)</div>
                        </div>
                        <div class="trow">
                            <div>National Labour Support Tax and Zakat</div>
                            <div>&nbsp;</div>
                            <div>(3,349)</div>
                            <div>(5,492)</div>
                        </div>
                        <div class="trow border-btm">
                            <div>Net cash from operating activities</div>
                            <div>&nbsp;</div>
                            <div class="sky-blue">651,811</div>
                            <div class="sky-blue">497,702</div>
                        </div>
                        <div class="trow">
                            <div><b>Cash flows from investing activities</b></div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                        </div>
                        <div class="trow">
                            <div>Deposits maturing after three months and cash at bank under lien</div>
                            <div>4</div>
                            <div>(7,403)</div>
                            <div>30,286</div>
                        </div>
                        <div class="trow">
                            <div>Proceeds from sale of investment securities</div>
                            <div>&nbsp;</div>
                            <div>7,916</div>
                            <div>1,919</div>
                        </div>
                        <div class="trow">
                            <div>Investments in securities</div>
                            <div>&nbsp;</div>
                            <div>(325)</div>
                            <div>(4,132)</div>
                        </div>
                        <div class="trow">
                            <div>Increase in dues from associates</div>
                            <div>&nbsp;</div>
                            <div>-</div>
                            <div>(7,039)</div>
                        </div>
                        <div class="trow">
                            <div>Acquisition of property and equipment (net)</div>
                            <div>&nbsp;</div>
                            <div>(282,799) </div>
                            <div>(173,837)</div>
                        </div>
                        <div class="trow">
                            <div>Acquisition of intangible assets (net)</div>
                            <div>&nbsp;</div>
                            <div>(33,417)</div>
                            <div>(43,977)</div>
                        </div>
                        <div class="trow">
                            <div>Net cash on acquisition of subsidiaries</div>
                            <div>&nbsp;</div>
                            <div>(11,703)</div>
                            <div>101,993</div>
                        </div>
                        <div class="trow">
                            <div>Interest received</div>
                            <div>&nbsp;</div>
                            <div>5,749</div>
                            <div>6,028</div>
                        </div>
                        <div class="trow">
                            <div>Dividends received</div>
                            <div>&nbsp;</div>
                            <div>383</div>
                            <div>253</div>
                        </div>
                        <div class="trow border-btm">
                            <div>Net cash used in investing activities</div>
                            <div>&nbsp;</div>
                            <div class="sky-blue">(321,599)</div>
                            <div class="sky-blue">(88,506)</div>
                        </div>
                        <div class="trow">
                            <div><b>Cash flows from financing activities</b></div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                        </div>
                        <div class="trow">
                            <div>Proceeds from bank borrowings </div>
                            <div>15</div>
                            <div>540,727</div>
                            <div>203,019</div>
                        </div>
                        <div class="trow">
                            <div>Repayment of bank borrowings</div>
                            <div>15</div>
                            <div>(587,387) </div>
                            <div>(288,901)</div>
                        </div>
                        <div class="trow">
                            <div>Repayment of lease liabilities</div>
                            <div>&nbsp;</div>
                            <div>(59,114)</div>
                            <div>-</div>
                        </div>
                        <div class="trow">
                            <div>Dividends paid to Company’s shareholders</div>
                            <div>&nbsp;</div>
                            <div>(129,705)</div>
                            <div>(151,017)</div>
                        </div>
                        <div class="trow">
                            <div>Dividends paid to minority shareholders of subsidiaries</div>
                            <div>&nbsp;</div>
                            <div>(5,047)</div>
                            <div>(1,569)</div>
                        </div>
                        <div class="trow">
                            <div>Finance costs paid – due to banks</div>
                            <div>&nbsp;</div>
                            <div>(112,438)</div>
                            <div>(52,966)</div>
                        </div>
                        <div class="trow border-btm">
                            <div>Net cash used in financing activities</div>
                            <div>&nbsp;</div>
                            <div class="sky-blue">(352,964)</div>
                            <div class="sky-blue">(291,434)</div>
                        </div>
                        <div class="trow">
                            <div><b>Net (decrease)/ increase in cash and cash equivalents</b></div>
                            <div>&nbsp;</div>
                            <div>(22,752) </div>
                            <div>117,762</div>
                        </div>
                        <div class="trow">
                            <div>Effects of exchange rate changes on cash and cash equivalents </div>
                            <div>&nbsp;</div>
                            <div>418</div>
                            <div>(13,461)</div>
                        </div>
                        <div class="trow">
                            <div>Transition adjustment on adoption of IFRS 9 </div>
                            <div>&nbsp;</div>
                            <div>-</div>
                            <div>(6,497)</div>
                        </div>
                        <div class="trow">
                            <div>Cash and cash equivalents at beginning of year</div>
                            <div>&nbsp;</div>
                            <div>304,236</div>
                            <div>206,432</div>
                        </div>
                        <div class="trow border-btm">
                            <div>Cash and cash equivalents at end of year</div>
                            <div>4</div>
                            <div class="sky-blue">281,902</div>
                            <div class="sky-blue">304,236</div>
                        </div>
                    </div>
                </div>
                <p >The accompanying notes are an integral part of these consolidated financial statements. </p>
            </div>
        </main>
  </div>
</template>

<script>
export default {
    methods:{
       
       
    },
    mounted(){
    }

}
</script>

<style lang="scss" scoped>
.sky_blue{
     color: #4eb9e9;;
}
.custom-table {
        .trow {
            &.head {
                background: #8A8C8E
;
                border: 0;
            }
            &.table-footer {
                background: #4eb9e9;
                border-bottom: none !important;
            }
            &.sky-blue {
                >div {
                    color: #4eb9e9;
                }
            }
            &.table-tp-head {
                border: 0;
                background: transparent;
                >div {
                    &:nth-child(3),
                    &:nth-child(4) {
                        background-color: white;
                        font-weight: 800;
                        color: #4eb9e9;
                    }
                    &:last-child {
                        border-left: 1px solid #fff;
                    }
                }
            }
            &.table-tp-headfull {
                background-color: #4eb9e9;
                border: 0;
            }
        }
        .border-btm {
            border-bottom: 1px solid #4eb9e9;
        }
        .border-top {
            border-top: 1px solid #4eb9e9 !important;
        }
        .b-right {
            border-right: 1px solid #fff !important;
        }
        p {
            font-size: 14px;
            &:not(:last-child) {
                margin-bottom: 7px;
            }
        }
    }
     .sky-blue {
    color: #4eb9e9;
}
</style>